(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  /* шапка поднимается к top:0 по мере того, как полоса уезжает вверх */
  (function () {
    var root = document.documentElement;
    var annH = parseFloat(getComputedStyle(root).getPropertyValue('--ann-h')) || 0;
    function onScroll() {
      var y = window.pageYOffset || 0;
      root.style.setProperty('--hdr-top', Math.max(0, annH - y) + 'px');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  document.querySelectorAll('[data-annbar]').forEach(function (bar) {
    if (bar.__annInit) return; bar.__annInit = true;
    var msgs = bar.querySelectorAll('.annbar__msg');
    var n = msgs.length;
    if (n <= 1) return;
    var i = 0, timer = null;
    var parsed = parseInt(bar.getAttribute('data-ann-speed'), 10);
    var speed = (isNaN(parsed) ? 5 : parsed) * 1000; /* 0 остаётся нулём — «авторотация выкл.» */
    function show() { for (var k = 0; k < n; k++) { msgs[k].classList.toggle('is-active', k === i); } }
    function go(d) { i = (i + d + n) % n; show(); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() { stop(); if (speed > 0) timer = setInterval(function () { go(1); }, speed); }
    var prev = bar.querySelector('[data-ann-prev]');
    var next = bar.querySelector('[data-ann-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); play(); });
    if (next) next.addEventListener('click', function () { go(1); play(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', play);
    show(); play();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bs__carousel').forEach((car) => {
    const track = car.querySelector('[data-bs-track]');
    const viewport = car.querySelector('.bs__viewport');
    const prev = car.querySelector('[data-bs-prev]');
    const next = car.querySelector('[data-bs-next]');
    if (!track || !viewport) return;
    const gap = () => parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
    const step = () => {
      const card = track.querySelector('.bs-card');
      return card ? card.offsetWidth + gap() : 300;
    };
    const transformMode = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (transformMode) {
      /* transform-режим: вьюпорт обрезает только по горизонтали, вертикаль видима (описание выпадает).
         Прокрутка: стрелки + горизонтальный wheel/трекпад + drag мышью. */
      let offset = 0;
      const maxOffset = () => Math.max(0, track.scrollWidth - viewport.clientWidth);
      const clampOff = (v) => Math.min(maxOffset(), Math.max(0, v));
      const apply = (smooth) => {
        track.style.transition = smooth ? 'transform 0.4s ease' : 'none';
        track.style.transform = 'translateX(' + (-offset) + 'px)';
      };
      const move = (dir) => { offset = clampOff(offset + dir * step() * 2); apply(true); };
      if (prev) prev.addEventListener('click', () => move(-1));
      if (next) next.addEventListener('click', () => move(1));
      window.addEventListener('resize', () => { offset = clampOff(offset); apply(false); });
      /* горизонтальный скролл колесом/трекпадом */
      viewport.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; /* вертикаль — отдаём странице */
        e.preventDefault();
        offset = clampOff(offset + e.deltaX);
        apply(false);
      }, { passive: false });
      /* перетаскивание мышью */
      let dragging = false, startX = 0, startOff = 0, moved = false;
      viewport.style.cursor = 'grab';
      viewport.addEventListener('pointerdown', (e) => {
        if (e.button !== 0) return;
        dragging = true; moved = false; startX = e.clientX; startOff = offset;
        /* захват указателя НЕ здесь: capture на pointerdown перенаправляет последующий
           click в viewport, и обычный клик по ссылке карточки перестаёт вести на товар */
      });
      viewport.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) {
          moved = true;
          viewport.style.cursor = 'grabbing';
          try { viewport.setPointerCapture(e.pointerId); } catch (_) {}
        }
        if (!moved) return;
        offset = clampOff(startOff - dx);
        apply(false);
      });
      const endDrag = (e) => {
        if (!dragging) return;
        dragging = false; viewport.style.cursor = 'grab';
        try { viewport.releasePointerCapture(e.pointerId); } catch (_) {}
      };
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      /* после перетаскивания не даём сработать клику-переходу по карточке */
      viewport.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    } else {
      /* тач: нативный скролл (свайп) + стрелки */
      if (prev) prev.addEventListener('click', () => viewport.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => viewport.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cdw]');
    if (!root || root.__cdw) return;
    root.__cdw = true;
    const panelSel = '[data-cdw-refresh]';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const open = () => {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cdw-lock');
      const closeBtn = root.querySelector('.cdw__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    };
    const close = () => {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cdw-lock');
    };

    const updateHeaderCount = (n) => {
      document.querySelectorAll('.hdr__act--cart').forEach((a) => {
        let b = a.querySelector('.hdr__cart-count');
        if (!b && n > 0) {
          b = document.createElement('span');
          b.className = 'hdr__cart-count';
          a.appendChild(b);
        }
        if (b) {
          b.textContent = n;
          if (n === 0) b.remove();
          else { b.classList.remove('is-atc-added'); void b.offsetWidth; b.classList.add('is-atc-added'); }
        }
      });
      const c = root.querySelector('[data-cdw-count]');
      if (c) c.textContent = n;
    };

    const refresh = async () => {
      const res = await fetch(window.location.pathname + '?sections=cart-drawer');
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector(panelSel);
      const cur = root.querySelector(panelSel);
      if (fresh && cur) cur.replaceWith(fresh);
      const freshCount = doc.querySelector('[data-cdw-count]');
      if (freshCount) updateHeaderCount(parseInt(freshCount.textContent, 10) || 0);
    };

    window.CartDrawer = { open, close, refresh };

    /* закрытие: крестик/фон/Escape (клики делегируем — контент перерисовывается) */
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-cdw-close]')) close();
      /* стрелки апсел-слайдера */
      const prev = e.target.closest('[data-cdw-up-prev]');
      const next = e.target.closest('[data-cdw-up-next]');
      if (prev || next) {
        const track = root.querySelector('[data-cdw-up-track]');
        if (track) track.scrollBy({ left: (next ? 1 : -1) * 288, behavior: 'smooth' });
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    /* количество/удаление */
    root.addEventListener('click', async (e) => {
      const plus = e.target.closest('[data-cdw-plus]');
      const minus = e.target.closest('[data-cdw-minus]');
      const rm = e.target.closest('[data-cdw-remove]');
      const btn = plus || minus || rm;
      if (!btn) return;
      const line = parseInt(btn.dataset.line, 10);
      let qty = 0;
      if (plus) qty = parseInt(btn.dataset.qty, 10) + 1;
      if (minus) qty = Math.max(0, parseInt(btn.dataset.qty, 10) - 1);
      const region = root.querySelector(panelSel);
      if (region) region.classList.add('is-busy');
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: qty })
        });
        await refresh();
      } catch (_) {
        if (region) region.classList.remove('is-busy');
      }
    });

    /* полёт картинки к иконке корзины */
    const fly = (img) => {
      if (reduce || !img) return;
      const target = document.querySelector('.hdr__act--cart');
      const from = img.getBoundingClientRect();
      const to = target ? target.getBoundingClientRect() : { left: window.innerWidth - 60, top: 24, width: 40, height: 40 };
      const ghost = document.createElement('img');
      ghost.src = img.currentSrc || img.src;
      ghost.className = 'cdw-fly';
      ghost.style.left = (from.left + from.width / 2 - 42) + 'px';
      ghost.style.top = (from.top + from.height / 2 - 42) + 'px';
      document.body.appendChild(ghost);
      requestAnimationFrame(() => {
        const dx = (to.left + to.width / 2) - (from.left + from.width / 2);
        const dy = (to.top + to.height / 2) - (from.top + from.height / 2);
        ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.25) rotate(6deg)';
        ghost.style.opacity = '0.25';
      });
      setTimeout(() => ghost.remove(), 600);
    };

    /* глобальный AJAX-перехват всех форм добавления в корзину */
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!form.action || !form.action.includes('/cart/add')) return;
      /* сабмит уже отменён обработчиком формы (PDP: не выбран размер) — не лезем,
         иначе уйдёт /cart/add с пустым id и фоллбэк утащит на страницу ошибки */
      if (e.defaultPrevented) return;
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const card = form.closest('.bs-card');
      const pdp = form.closest('[data-pdp]');
      const srcImg = (card && card.querySelector('.bs-card__img')) || (pdp && pdp.querySelector('[data-pdp-main]'));
      if (btn) btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!res.ok) throw new Error('add failed');
        /* на странице корзины дровер поверх корзины не нужен — обновляем саму страницу */
        if (document.querySelector('.crt')) { window.location.reload(); return; }
        fly(srcImg);
        if (btn) { btn.classList.remove('is-atc-added'); void btn.offsetWidth; btn.classList.add('is-atc-added'); }
        await refresh();
        setTimeout(open, reduce ? 0 : 380);
      } catch (_) {
        /* фоллбэк — обычная отправка формы */
        form.submit();
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Служебные параметры поиска Shopify (_pos/_psq/_psid/_ss/_v) уже засчитаны
  // сервером для аналитики — чистим адресную строку, не трогая остальные
  // параметры (variant, utm и т.д.) и не перезагружая страницу.
  (function () {
    try {
      var junk = ['_pos', '_psq', '_psid', '_ss', '_v'];
      var u = new URL(window.location.href);
      var changed = false;
      junk.forEach(function (k) { if (u.searchParams.has(k)) { u.searchParams.delete(k); changed = true; } });
      if (changed && window.history && history.replaceState) {
        var q = u.searchParams.toString();
        history.replaceState(null, '', u.pathname + (q ? '?' + q : '') + u.hash);
      }
    } catch (e) { /* старые браузеры без URL API — оставляем как есть */ }
  })();

  // Static newsletter form posts to /contact with form_type=customer.
  // On success Shopify redirects back with ?customer_posted=true — reveal the note.
  (function () {
    if (!/[?&]customer_posted=true/.test(window.location.search)) return;
    document.querySelectorAll('[data-ftr-success]').forEach(function (el) { el.hidden = false; });
  })();

  // Ховер-описание карточки (.bs-card__desc): портал в body.
  // Плашка выпадает ниже кромки секции; внутри секции её срезает следующая
  // полоса (соседний stacking context), а поднятие секции по z накрывало
  // скруглённую шапку соседнего band'а. Перенос узла в body с fixed-координатами
  // выводит плашку поверх всего, не трогая наслоение полос.
  (function () {
    var ported = null, home = null, card = null;
    function restore() {
      if (!ported) return;
      ported.classList.remove('is-ported');
      ported.style.left = ported.style.top = ported.style.width = '';
      home.parentNode.insertBefore(ported, home);
      home.remove();
      ported = null; home = null; card = null;
    }
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch') return;
      var c = e.target.closest ? e.target.closest('.bs-card') : null;
      if (card) {
        if (c === card) return;
        if (ported && ported.contains(e.target)) return;
        restore();
      }
      if (!c) return;
      var d = c.querySelector('.bs-card__desc');
      if (!d) return;
      var r = c.getBoundingClientRect();
      home = document.createElement('i');
      home.style.display = 'none';
      d.parentNode.insertBefore(home, d);
      document.body.appendChild(d);
      d.style.left = r.left + 'px';
      /* rect снят ДО того, как отработал ховер-подъём карточки (translateY(-5px)),
         поэтому вычитаем его вручную: иначе плашка встаёт на 5px ниже поднявшейся
         карточки и на стыке видна щель. Лишнее перекрытие в момент анимации
         незаметно — плашка непрозрачная и лежит поверх. */
      d.style.top = (r.bottom - 20 - 5) + 'px';
      d.style.width = r.width + 'px';
      d.classList.add('is-ported');
      ported = d; card = c;
    });
    document.addEventListener('pointerout', function (e) {
      if (!card) return;
      var to = e.relatedTarget;
      if (to && (card.contains(to) || (ported && ported.contains(to)))) return;
      restore();
    });
    window.addEventListener('scroll', restore, { passive: true });
  })();

  // pill-ring: точная геометрия в пикселях (Safari не умеет calc() в SVG-геометрии,
  // а проценты + rx:999 без клампа давали артефакты). Штрих утоплен ПОЛНОСТЬЮ
  // внутрь заливки (0.75px от кромки): его наружная половина на тёмном фоне
  // давала грязный антиалиасинг на дугах. rx: пилюля = половина внутренней
  // высоты, прямоугольные поля = радиус родителя − 0.75. CSS — no-JS фолбэк.
  (function () {
    var parents = [];
    document.querySelectorAll('.pill-ring').forEach(function (svg) {
      var p = svg.parentElement;
      if (p && parents.indexOf(p) === -1) parents.push(p);
    });
    if (!parents.length) return;
    var apply = function (p) {
      var b = p.getBoundingClientRect();
      if (!b.height) return;
      var rect = p.querySelector('.pill-ring rect');
      if (!rect) return;
      var br = parseFloat(getComputedStyle(p).borderTopLeftRadius) || 0;
      var innerH = b.height - 1.5;
      var isPill = br >= b.height / 2 - 1;
      var rx = isPill ? innerH / 2 : Math.max(0, br - 0.75);
      var s = rect.style;
      s.x = '0.75px';
      s.y = '0.75px';
      s.width = (b.width - 1.5).toFixed(2) + 'px';
      s.height = innerH.toFixed(2) + 'px';
      s.rx = rx.toFixed(2) + 'px';
    };
    parents.forEach(apply);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (entries) {
        entries.forEach(function (e) { apply(e.target); });
      });
      parents.forEach(function (p) { ro.observe(p); });
    } else {
      window.addEventListener('resize', function () { parents.forEach(apply); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-header]').forEach((hdr) => {
    const hero = document.querySelector('[data-phero]');
    let ticking = false;

    const update = () => {
      ticking = false;
      // condense the pill once we reach the section after the hero (Best Sellers).
      // offsetTop секции-соседа учитывает и фазу «наезда» на hero (её отрицательный margin).
      // без hero (страницы товара/корзины) прячем лого почти сразу — как на главной после hero
      let threshold = window.innerHeight * 0.2;
      if (hero) {
        const heroWrap = hero.closest('.shopify-section');
        const next = heroWrap && heroWrap.nextElementSibling;
        threshold = next
          ? next.offsetTop - window.innerHeight * 1.15
          : hero.offsetTop + hero.offsetHeight - window.innerHeight * 1.15;
      }
      hdr.classList.toggle('is-scrolled', window.scrollY > threshold);

      // adapt logo/icon colour to the section currently under the header
      let theme = 'dark';
      const els = document.elementsFromPoint(window.innerWidth / 2, 64);
      for (const el of els) {
        const s = el.closest && el.closest('[data-header-theme]');
        if (s) { theme = s.dataset.headerTheme || 'dark'; break; }
      }
      hdr.classList.toggle('hdr--on-light', theme === 'light');
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();

    const burger = hdr.querySelector('[data-hdr-burger]');
    const drawer = hdr.querySelector('[data-hdr-drawer]');
    if (burger && drawer) {
      burger.addEventListener('click', () => {
        const open = drawer.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-phero]').forEach((root) => {
    const count = parseInt(root.dataset.count, 10) || 0;
    if (count === 0) return;

    const bg = root.querySelector('[data-phero-bg]');
    const jackets = root.querySelectorAll('[data-phero-jacket]');
    const panels = root.querySelectorAll('[data-phero-panel]');
    const prices = root.querySelectorAll('[data-phero-price]');
    let current = -1;
    let ticking = false;

    const apply = (index) => {
      if (index === current) return;
      current = index;
      const panel = panels[index];
      if (panel) {
        if (bg) {
          if (panel.dataset.bgimage) {
            if (panel.dataset.bg) bg.style.backgroundColor = panel.dataset.bg;
            bg.style.backgroundImage = 'url("' + panel.dataset.bgimage + '")';
          } else {
            bg.style.backgroundImage = 'none';
            if (panel.dataset.bg) bg.style.backgroundColor = panel.dataset.bg;
          }
        }
        root.classList.toggle('phero--dark-text', panel.dataset.dark === '1');
      }
      jackets.forEach((j, i) => {
        j.classList.remove('is-main', 'is-preview', 'is-past', 'is-future');
        if (i === index) j.classList.add('is-main');
        else if (i === index + 1) j.classList.add('is-preview');
        else if (i < index) j.classList.add('is-past');
        else j.classList.add('is-future');
      });
      panels.forEach((p, i) => p.classList.toggle('is-active', i === index));
      prices.forEach((p, i) => p.classList.toggle('is-active', i === index));
    };

    const isStacked = () => window.matchMedia('(max-width: 900px)').matches;

    const update = () => {
      ticking = false;
      if (isStacked()) return; /* на мобиле слайд не меняется по скроллу */
      /* минус вьюпорт пиннинга и минус 100vh фазы наезда следующей секции */
      const total = root.offsetHeight - window.innerHeight * 2;
      const scrolled = Math.min(Math.max(-root.getBoundingClientRect().top, 0), total);
      const progress = total > 0 ? scrolled / total : 0;
      apply(Math.min(count - 1, Math.floor(progress * count + 0.0001)));
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    const stepTo = (i) => {
      i = Math.max(0, Math.min(count - 1, i));
      if (isStacked()) { apply(i); return; } /* мобила: переключаем слайд напрямую */
      const total = root.offsetHeight - window.innerHeight * 2;
      const y = root.offsetTop + ((i + 0.5) / count) * total;
      window.scrollTo({ top: y, behavior: 'smooth' });
    };

    const prev = root.querySelector('[data-phero-prev]');
    const next = root.querySelector('[data-phero-next]');
    if (prev) prev.addEventListener('click', () => stepTo(current - 1));
    if (next) next.addEventListener('click', () => stepTo(current + 1));

    apply(0);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (() => {
    /* toggle форм: кнопка и её «отмена» несут один data-adr-toggle */
    document.querySelectorAll('[data-adr-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-adr-toggle');
        const form = document.querySelector('[data-adr-form="' + id + '"]');
        const view = document.querySelector('[data-adr-view="' + id + '"]');
        if (!form) return;
        const open = form.hidden;
        form.hidden = !open;
        if (view) view.hidden = open;
      });
    });

    /* страна → провинции: option_tags кладут JSON в data-provinces */
    document.querySelectorAll('[data-adr-country]').forEach((country) => {
      const scope = country.closest('form');
      const province = scope.querySelector('[data-adr-province]');
      const wrap = scope.querySelector('[data-adr-province-wrap]');
      if (!province || !wrap) return;
      const fill = () => {
        let list = [];
        try {
          list = JSON.parse(country.options[country.selectedIndex].getAttribute('data-provinces') || '[]');
        } catch (e) { /* битый JSON — считаем, что провинций нет */ }
        province.innerHTML = '';
        list.forEach((p) => {
          const o = document.createElement('option');
          o.value = p[0];
          o.textContent = p[1];
          province.appendChild(o);
        });
        wrap.hidden = list.length === 0;
      };
      const def = country.getAttribute('data-default');
      if (def) country.value = def;
      fill();
      const pdef = province.getAttribute('data-default');
      if (pdef) province.value = pdef;
      country.addEventListener('change', fill);
    });

    /* после ошибки сабмита страница перерисуется — раскрываем форму с ошибкой */
    document.querySelectorAll('[data-adr-form]').forEach((form) => {
      if (!form.querySelector('.acc__err')) return;
      form.hidden = false;
      const view = document.querySelector('[data-adr-view="' + form.getAttribute('data-adr-form') + '"]');
      if (view) view.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /* живой пересчёт корзины: +/−/ввод/удаление → /cart/change.js → перерисовка секции
     сервером (Section Rendering API). Делегируем на document — секция заменяется целиком.
     Фоллбэк без JS: инпуты updates[] уходят с сабмитом Checkout. */
  (() => {
    if (window.__crtBound) return;
    window.__crtBound = true;

    const sectionWrap = () => {
      const crt = document.querySelector('.crt');
      return crt ? crt.closest('.shopify-section') : null;
    };

    const setQty = async (line, qty) => {
      const wrap = sectionWrap();
      if (!wrap) return;
      const crt = wrap.querySelector('.crt');
      if (crt) crt.classList.add('is-busy');
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line, quantity: qty })
        });
        const id = wrap.id.replace('shopify-section-', '');
        const res = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(id));
        const data = await res.json();
        if (data[id]) {
          const doc = new DOMParser().parseFromString(data[id], 'text/html');
          const fresh = doc.body.firstElementChild;
          if (fresh) wrap.innerHTML = fresh.innerHTML;
        }
        if (window.CartDrawer) window.CartDrawer.refresh();
      } catch (_) {
        window.location.reload();
      }
    };

    document.addEventListener('click', (e) => {
      const plus = e.target.closest('[data-crt-plus]');
      const minus = e.target.closest('[data-crt-minus]');
      const rm = e.target.closest('[data-crt-remove]');
      if (rm) {
        e.preventDefault();
        setQty(parseInt(rm.dataset.line, 10), 0);
        return;
      }
      if (!plus && !minus) return;
      const btn = plus || minus;
      const cur = parseInt(btn.dataset.qty, 10);
      setQty(parseInt(btn.dataset.line, 10), Math.max(0, cur + (plus ? 1 : -1)));
    });

    document.addEventListener('change', (e) => {
      const inp = e.target.closest('[data-crt-qty]');
      if (!inp) return;
      const q = Math.max(0, parseInt(inp.value, 10) || 0);
      setQty(parseInt(inp.dataset.line, 10), q);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-col-sort]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* переключатель плотности сетки; выбор запоминается */
  (() => {
    const grid = document.querySelector('[data-col-grid]');
    const btns = document.querySelectorAll('[data-col-view]');
    if (!grid || !btns.length) return;
    const KEY = 'tm_col_view';
    const apply = (n) => {
      grid.classList.remove('col__grid--2', 'col__grid--3', 'col__grid--5');
      if (n !== '4') grid.classList.add('col__grid--' + n);
      btns.forEach((b) => b.classList.toggle('is-on', b.dataset.colView === n));
      try { localStorage.setItem(KEY, n); } catch (_) {}
    };
    let saved = '4';
    try { saved = localStorage.getItem(KEY) || '4'; } catch (_) {}
    if (!['2', '3', '4', '5'].includes(saved)) saved = '4';
    apply(saved);
    btns.forEach((b) => b.addEventListener('click', () => apply(b.dataset.colView)));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (new URLSearchParams(window.location.search).get('contact_posted') !== 'true') return;
    document.querySelectorAll('[data-ct-success]').forEach((el) => { el.hidden = false; });
    const card = document.querySelector('.ct__card');
    if (card) card.scrollIntoView({ block: 'center' });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  (() => {
    const login = document.querySelector('[data-lgn-login]');
    const recover = document.querySelector('[data-lgn-recover]');
    if (!login || !recover) return;
    const show = (rec) => {
      login.hidden = rec;
      recover.hidden = !rec;
    };
    document.querySelectorAll('[data-lgn-show-recover]').forEach((a) =>
      a.addEventListener('click', (e) => { e.preventDefault(); show(true); })
    );
    document.querySelectorAll('[data-lgn-show-login]').forEach((a) =>
      a.addEventListener('click', (e) => { e.preventDefault(); show(false); })
    );
    /* Shopify после сабмита восстановления возвращает на #recover */
    if (window.location.hash === '#recover' || document.querySelector('[data-lgn-recover-ok]')) show(true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-pdp]').forEach((root) => {
    /* галерея */
    const main = root.querySelector('[data-pdp-main]');
    root.querySelectorAll('[data-pdp-thumb]').forEach((th) => {
      th.addEventListener('click', () => {
        if (main) { main.src = th.dataset.full; main.removeAttribute('srcset'); }
        root.querySelectorAll('[data-pdp-thumb]').forEach((t) => t.classList.toggle('is-active', t === th));
      });
    });

    /* прогрев полноразмеров: без него клик по миниатюре ждал загрузку 1200px (~секунда) */
    const pdpWarm = () => root.querySelectorAll('[data-pdp-thumb]').forEach((t) => {
      if (t.dataset.full) { const im = new Image(); im.src = t.dataset.full; }
    });
    if ('requestIdleCallback' in window) { requestIdleCallback(pdpWarm, { timeout: 3000 }); } else { setTimeout(pdpWarm, 1500); }

    /* зум по наведению: картинка увеличивается и следует за курсором; только hover-устройства */
    const media = root.querySelector('.pdp__media');
    if (media && main && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      media.classList.add('pdp__media--zoomable');
      media.addEventListener('mousemove', (e) => {
        const r = media.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width) * 100;
        const y = ((e.clientY - r.top) / r.height) * 100;
        main.style.transformOrigin = x + '% ' + y + '%';
      });
      media.addEventListener('mouseenter', () => main.classList.add('is-zoomed'));
      media.addEventListener('mouseleave', () => main.classList.remove('is-zoomed'));
    }

    /* варианты */
    const dataEl = root.querySelector('[data-pdp-data]');
    const data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], options: [] };
    const money = (cents) => {
      const fmt = window.PDP_MONEY_FORMAT;
      const n = cents / 100;
      if (!fmt) return '$' + n.toFixed(2);
      const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      const key = m ? m[1] : 'amount';
      let out;
      switch (key) {
        case 'amount_no_decimals': out = String(Math.round(n)); break;
        case 'amount_with_comma_separator': out = n.toFixed(2).replace('.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = String(Math.round(n)); break;
        case 'amount_with_apostrophe_separator': out = n.toFixed(2); break;
        default: out = n.toFixed(2);
      }
      const el = document.createElement('span');
      el.innerHTML = fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
      return el.textContent;
    };
    const state = [];
    const optGroups = Array.from(root.querySelectorAll('[data-pdp-opt]'));
    optGroups.forEach((grp, gi) => {
      const on = grp.querySelector('.pdp__pill.is-on');
      state[gi] = on ? on.dataset.pdpValue : null;
      grp.querySelectorAll('[data-pdp-value]').forEach((pill) => {
        pill.addEventListener('click', () => {
          state[gi] = pill.dataset.pdpValue;
          const hint = grp.querySelector('.pdp__opt-need');
          if (hint) hint.remove();
          syncOptions();
          syncGallery();
          applyVariant();
        });
      });
    });
    /* каскад опций (зеркало Liquid-логики разметки): для опции i достижимы значения
       вариантов, совпадающих с выбором опций 0..i-1. Недостижимые пилюли прячем;
       опцию с единственным достижимым значением выбираем молча и прячем целиком.
       Слетевший выбор (был FULL/2″ → стал Standart) НЕ подменяем первым попавшимся —
       обнуляем: покупатель должен выбрать размер сам, иначе купит не ту колбу. */
    const syncOptions = () => {
      optGroups.forEach((grp, gi) => {
        const avail = [];
        data.variants.forEach((v) => {
          for (let j = 0; j < gi; j++) if (v.options[j] !== state[j]) return;
          if (avail.indexOf(v.options[gi]) < 0) avail.push(v.options[gi]);
        });
        if (avail.indexOf(state[gi]) < 0) state[gi] = avail.length === 1 ? avail[0] : null;
        grp.querySelectorAll('[data-pdp-value]').forEach((p) => {
          p.hidden = avail.indexOf(p.dataset.pdpValue) < 0;
          p.classList.toggle('is-on', p.dataset.pdpValue === state[gi]);
        });
        grp.hidden = avail.length < 2;
      });
    };
    /* подсказка «выбери опцию»: живёт в лейбле группы, перезапускает встряску */
    const needHint = (gi) => {
      const grp = optGroups[gi];
      const label = grp && grp.querySelector('.pdp__opt-label');
      if (!label) return;
      let span = label.querySelector('.pdp__opt-need');
      if (!span) {
        span = document.createElement('span');
        span.className = 'pdp__opt-need';
        label.appendChild(span);
      }
      span.textContent = '— ' + (window.PDP_T_CHOOSE || 'please select');
      span.classList.remove('is-anim');
      void span.offsetWidth;
      span.classList.add('is-anim');
      const r = grp.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) grp.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    /* наборы фото комплектаций: миниатюра с data-set видна, когда её слаг —
       префикс handleize-значения одной из выбранных опций; без метки — всегда.
       Если активная миниатюра спряталась — перещёлкиваем на первую видимую. */
    const galleryThumbs = Array.from(root.querySelectorAll('[data-pdp-thumb]'));
    const handleize = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const syncGallery = () => {
      if (!galleryThumbs.length) return;
      const sels = state.filter(Boolean).map(handleize);
      let firstVis = null;
      let activeHidden = false;
      galleryThumbs.forEach((t) => {
        const tag = t.dataset.set;
        const show = !tag || sels.some((h) => h.indexOf(tag) === 0);
        t.hidden = !show;
        if (show && !firstVis) firstVis = t;
        if (!show && t.classList.contains('is-active')) activeHidden = true;
      });
      if (activeHidden && firstVis) firstVis.click();
    };
    const atc = root.querySelector('[data-pdp-atc]');
    const atcLabel = root.querySelector('[data-pdp-atc-label]');
    const stickyAtc = root.querySelector('[data-pdp-sticky-atc]');
    const applyVariant = () => {
      /* выбор не завершён (опция появилась и ждёт решения): цену показываем по первому
         кандидату из совпавших опций, id чистим — сабмит перехватит needHint.
         Экспресс-оплату (Apple Pay/PayPal) на это время прячет CSS по is-incomplete. */
      const incomplete = state.some((s) => s == null);
      root.classList.toggle('is-incomplete', incomplete);
      const v = incomplete ? null : data.variants.find((vv) => vv.options.every((o, i) => o === state[i]));
      const shown = v || data.variants.find((vv) => vv.options.every((o, i) => state[i] == null || o === state[i]));
      const idInp = root.querySelector('[data-pdp-id]');
      if (idInp) idInp.value = v ? v.id : '';
      if (shown) {
        const priceEl = root.querySelector('[data-pdp-price]');
        if (priceEl) priceEl.textContent = money(shown.price);
        const stickyPrice = root.querySelector('[data-pdp-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = money(shown.price);
        const cmp = root.querySelector('[data-pdp-compare]');
        const badge = root.querySelector('[data-pdp-badge]');
        const hasCmp = shown.compare_at_price && shown.compare_at_price > shown.price;
        if (cmp) { cmp.hidden = !hasCmp; if (hasCmp) cmp.textContent = money(shown.compare_at_price); }
        if (badge) { badge.hidden = !hasCmp; if (hasCmp) badge.textContent = '−' + Math.round((shown.compare_at_price - shown.price) * 100 / shown.compare_at_price) + '%'; }
      }
      if (incomplete) {
        [atc, stickyAtc].forEach((b) => { if (b) b.disabled = false; });
        if (atcLabel) atcLabel.textContent = window.PDP_T_ADD || 'Add to cart';
        const stockPend = root.querySelector('[data-pdp-stock]');
        if (stockPend) stockPend.hidden = true;
        return;
      }
      if (!v) {
        /* такой комбинации опций не существует — блокируем покупку, не оставляя старый id */
        [atc, stickyAtc].forEach((b) => { if (b) b.disabled = true; });
        if (atcLabel) atcLabel.textContent = window.PDP_T_UNAVAILABLE || 'Unavailable';
        return;
      }
      [atc, stickyAtc].forEach((b) => { if (b) b.disabled = !v.available; });
      if (atcLabel) atcLabel.textContent = v.available ? (window.PDP_T_ADD || 'Add to cart') : (window.PDP_T_SOLD || 'Sold out');
      /* индикатор остатка: три состояния in/low/critical, заполнение = остаток/порог */
      const stockWrap = root.querySelector('[data-pdp-stock]');
      if (stockWrap && stockWrap.hasAttribute('data-stock-forced')) {
        /* forced/smart: содержимое не пересчитываем — только видимость по наличию варианта */
        stockWrap.hidden = !v.available;
      } else if (stockWrap) {
        const q = data.inventory ? data.inventory[String(v.id)] : null;
        const thr = data.threshold;
        const show = thr > 0 && typeof q === 'number' && q > 0;
        stockWrap.hidden = !show;
        if (show) {
          const crit = Math.max(1, Math.floor(thr / 2));
          const tier = q > thr ? 'in' : (q > crit ? 'low' : 'critical');
          stockWrap.classList.remove('pdp__stock--in', 'pdp__stock--low', 'pdp__stock--critical');
          stockWrap.classList.add('pdp__stock--' + tier);
          const txt = stockWrap.querySelector('[data-pdp-stock-txt]');
          if (txt) {
            if (tier === 'in') txt.textContent = window.PDP_T_STOCK_IN || 'In stock';
            else if (tier === 'low') txt.textContent = (window.PDP_T_STOCK_LOW || 'Low stock: [COUNT] left').replace('[COUNT]', q);
            else txt.textContent = (window.PDP_T_ONLY_LEFT || 'Only [COUNT] left').replace('[COUNT]', q);
          }
          const barEl = stockWrap.querySelector('[data-pdp-stock-bar]');
          if (barEl) barEl.style.width = (tier === 'in' ? 100 : Math.max(10, Math.round(q * 100 / thr))) + '%';
        }
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      /* сообщаем другим секциям (OBT) о смене варианта */
      document.dispatchEvent(new CustomEvent('pdp:variant', { detail: { id: v.id, price: v.price, available: v.available } }));
    };
    /* нормализация на загрузке: Liquid уже спрятал недостижимое, вызовы идемпотентны;
       чинят кейс, когда активная миниатюра оказалась из чужого набора */
    syncOptions();
    syncGallery();

    /* мобильный sticky-бар: показываем, когда основная кнопка ушла вверх за экран */
    const bar = root.querySelector('[data-pdp-sticky]');
    const atcBtn = atc;
    const form = root.querySelector('.pdp__form');
    /* выбор не завершён — сабмит не уходит, просим выбрать первую пустую опцию */
    if (form) {
      form.addEventListener('submit', (e) => {
        const miss = state.indexOf(null);
        if (miss < 0) return;
        e.preventDefault();
        needHint(miss);
      });
    }
    if (bar && atcBtn) {
      const syncBar = () => {
        const show = atcBtn.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      window.addEventListener('scroll', syncBar, { passive: true });
      window.addEventListener('resize', syncBar);
      syncBar();
      const stickyBtn = root.querySelector('[data-pdp-sticky-atc]');
      if (stickyBtn && form) stickyBtn.addEventListener('click', () => { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
  });

  /* поп-ап size guide */
  (() => {
    const modal = document.querySelector('[data-sg-modal]');
    const openBtn = document.querySelector('[data-sg-open]');
    if (!modal || !openBtn) return;
    /* портал в body: внутри .band.stack (z-index:1) свой stacking-контекст —
       шапка и cart drawer рисовались бы поверх модалки (как у hover-описаний карточек) */
    document.body.appendChild(modal);
    let last = null;
    const show = () => {
      last = document.activeElement;
      modal.hidden = false;
      /* lazy-картинки внутри display:none браузер не грузит и после показа
         (интерсекция не пересчитывается) — при первом открытии форсируем */
      modal.querySelectorAll('img[loading="lazy"]').forEach((im) => { im.loading = 'eager'; });
      document.documentElement.style.overflow = 'hidden';
      modal.querySelector('.pdp__sg-x').focus();
    };
    const hide = () => {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (last && last.focus) last.focus();
    };
    openBtn.addEventListener('click', show);
    modal.querySelectorAll('[data-sg-close]').forEach((b) => b.addEventListener('click', hide));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) hide(); });

    /* тумблер систем единиц: cm/mm → дюймы, g → lb (крупное) или oz (мелкое),
       диапазоны целиком. Владелец заполняет метрику; ПО УМОЛЧАНИЮ показываем
       американскую систему (приоритет — трафик из США), метрика — по клику. */
    const specs = modal.querySelector('[data-sg-specs]');
    const unitsWrap = modal.querySelector('[data-sg-units]');
    if (specs && unitsWrap) {
      const cells = specs.querySelectorAll('td:last-child');
      cells.forEach((td) => { td.dataset.sgOrig = td.textContent; });
      const num = (v) => parseFloat(String(v).replace(',', '.'));
      const fmt = (v) => {
        const s = v < 1 ? v.toFixed(2) : v.toFixed(1);
        return s.replace(/\.0$/, '');
      };
      const inch = (n, perInch) => fmt(num(n) / perInch);
      const grams = (a, b, dash) => {
        /* один масштаб на всё выражение: диапазон «0.4 lb – 7 oz» был бы кашей */
        const hi = Math.max(num(a), b === undefined ? 0 : num(b));
        const lb = hi >= 1000;
        const conv = (v) => fmt(num(v) / (lb ? 453.592 : 28.35));
        const unit = lb ? ' lb' : ' oz';
        return b === undefined ? conv(a) + unit : conv(a) + dash + conv(b) + unit;
      };
      const toUs = (t) => {
        let out = t
          .replace(/(\d+(?:[.,]\d+)?)(\s*[–—-]\s*)(\d+(?:[.,]\d+)?)\s*cm\b/gi, (m, a, dash, b) => inch(a, 2.54) + dash + inch(b, 2.54) + '″')
          .replace(/(\d+(?:[.,]\d+)?)\s*cm\b/gi, (m, a) => inch(a, 2.54) + '″')
          .replace(/(\d+(?:[.,]\d+)?)(\s*[–—-]\s*)(\d+(?:[.,]\d+)?)\s*mm\b/gi, (m, a, dash, b) => inch(a, 25.4) + dash + inch(b, 25.4) + '″')
          .replace(/(\d+(?:[.,]\d+)?)\s*mm\b/gi, (m, a) => inch(a, 25.4) + '″');
        /* граммы не трогаем, если владелец уже написал oz/lb сам («320 g (11.3 oz)») */
        if (!/\b(oz|lb)\b/i.test(out)) {
          out = out
            .replace(/(\d+(?:[.,]\d+)?)(\s*[–—-]\s*)(\d+(?:[.,]\d+)?)\s*g\b/gi, (m, a, dash, b) => grams(a, b, dash))
            .replace(/(\d+(?:[.,]\d+)?)\s*g\b/gi, (m, a) => grams(a));
        }
        return out;
      };
      /* обратная сторона: имперские «родные» значения (цилиндры 1.75″, lb)
         достраиваются в метрику. Дюймы: ″/"/inch, а голое «in» — только сразу
         после числа и не перед словом/цифрой («3.6 in» — дюймы; «handcrafted
         in Europe», «2 in 1» — предлог, не трогаем). Оба вида считаются от
         оригинала — двойного округления нет. */
      const toMetric = (t) => {
        /* значение уже содержит метрику (или дубль «320 g (11.3 oz)») — не трогаем */
        if (/\b(?:cm|mm|g)\b/i.test(t)) return t;
        return t
        .replace(/(\d+(?:[.,]\d+)?)(\s*[–—-]\s*)(\d+(?:[.,]\d+)?)\s*(?:″|"|inch(?:es)?\b|in\b(?!\s*\w))/gi, (m, a, dash, b) => fmt(num(a) * 2.54) + dash + fmt(num(b) * 2.54) + ' cm')
        .replace(/(\d+(?:[.,]\d+)?)\s*(?:″|"|inch(?:es)?\b|in\b(?!\s*\w))/gi, (m, a) => fmt(num(a) * 2.54) + ' cm')
        .replace(/(\d+(?:[.,]\d+)?)(\s*[–—-]\s*)(\d+(?:[.,]\d+)?)\s*lbs?\b/gi, (m, a, dash, b) => Math.round(num(a) * 453.592) + dash + Math.round(num(b) * 453.592) + ' g')
        .replace(/(\d+(?:[.,]\d+)?)\s*lbs?\b/gi, (m, a) => Math.round(num(a) * 453.592) + ' g')
        .replace(/(\d+(?:[.,]\d+)?)\s*oz\b/gi, (m, a) => Math.round(num(a) * 28.35) + ' g');
      };
      const apply = (unit) => {
        unitsWrap.classList.toggle('is-metric', unit === 'cm');
        unitsWrap.querySelectorAll('button').forEach((b) => b.classList.toggle('is-on', b.dataset.u === unit));
        cells.forEach((td) => { td.textContent = unit === 'in' ? toUs(td.dataset.sgOrig) : toMetric(td.dataset.sgOrig); });
      };
      unitsWrap.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () => apply(btn.dataset.u));
      });
      apply('in'); /* США по умолчанию */
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["often-bought-together"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-obt]').forEach((root) => {
    const checks = [...root.querySelectorAll('[data-obt-check]')];
    const totalEl = root.querySelector('[data-obt-total]');
    const addBtn = root.querySelector('[data-obt-add]');
    const errEl = root.querySelector('[data-obt-err]');
    const money = (cents) => {
      const fmt = window.PDP_MONEY_FORMAT;
      const n = cents / 100;
      if (!fmt) return '$' + n.toFixed(2);
      const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      const key = m ? m[1] : 'amount';
      let out;
      switch (key) {
        case 'amount_no_decimals': out = String(Math.round(n)); break;
        case 'amount_with_comma_separator': out = n.toFixed(2).replace('.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = String(Math.round(n)); break;
        default: out = n.toFixed(2);
      }
      const el = document.createElement('span');
      el.innerHTML = fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
      return el.textContent;
    };
    const fullEl = root.querySelector('[data-obt-total-full]');
    const saveEl = root.querySelector('[data-obt-save]');
    const saveAmtEl = root.querySelector('[data-obt-save-amt]');
    const recalc = () => {
      const picked = checks.filter(c => c.checked && !c.disabled);
      const sum = picked.reduce((s, c) => s + parseInt(c.dataset.price, 10), 0);
      /* скидка кода действует от 2 позиций; сумму скидки Shopify отбрасывает
         вниз до цента (floor) — считаем так же, чтобы цифры сошлись с чекаутом */
      const pct = window.OBT_DISCOUNT_PCT || 0;
      const off = picked.length >= 2 && pct > 0 ? Math.floor(sum * pct / 100) : 0;
      if (totalEl) totalEl.textContent = money(sum - off);
      if (fullEl) { fullEl.hidden = off === 0; fullEl.textContent = money(sum); }
      if (saveEl) saveEl.hidden = off === 0;
      if (saveAmtEl && off > 0) saveAmtEl.textContent = money(off);
      if (addBtn) addBtn.disabled = sum === 0;
    };
    checks.forEach(c => c.addEventListener('change', recalc));
    recalc();

    /* смена варианта в бай-боксе PDP → актуализируем «этот товар» в бандле */
    document.addEventListener('pdp:variant', (e) => {
      const cur = root.querySelector('[data-obt-current]');
      if (!cur || !e.detail) return;
      cur.dataset.id = e.detail.id;
      cur.dataset.price = e.detail.price;
      cur.disabled = !e.detail.available;
      if (!e.detail.available) cur.checked = false;
      const priceEl = root.querySelector('[data-obt-current-price]');
      if (priceEl) priceEl.textContent = money(e.detail.price);
      recalc();
    });

    if (addBtn) addBtn.addEventListener('click', async () => {
      const items = checks.filter(c => c.checked && !c.disabled).map(c => ({ id: parseInt(c.dataset.id, 10), quantity: 1 }));
      if (!items.length) return;
      addBtn.disabled = true;
      if (errEl) errEl.hidden = true;
      try {
        const res = await fetch((window.OBT_ADD_URL || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('add failed');
        /* прикрепляем промокод бандла к сессии: /discount/CODE кладёт куку,
           на чекауте код подставится сам; провал не ломает добавление */
        if (window.OBT_DISCOUNT_URL) {
          try { await fetch(window.OBT_DISCOUNT_URL, { credentials: 'same-origin' }); } catch (e) {}
        }
        if (window.CartDrawer) {
          await window.CartDrawer.refresh();
          window.CartDrawer.open();
          addBtn.disabled = false;
        } else {
          window.location.href = window.OBT_CART_URL || '/cart';
        }
      } catch (e) {
        addBtn.disabled = false;
        if (errEl) errEl.hidden = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-anatomy"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-anatomy]').forEach((root) => {
    const spots = root.querySelectorAll('.anatomy__spot');
    const closeAll = (except) => {
      spots.forEach((s) => {
        if (s !== except) {
          s.classList.remove('is-open');
          const d = s.querySelector('[data-an-dot]');
          if (d) d.setAttribute('aria-expanded', 'false');
        }
      });
    };
    spots.forEach((spot) => {
      const dot = spot.querySelector('[data-an-dot]');
      if (!dot) return;
      dot.addEventListener('click', (e) => {
        e.stopPropagation();
        const open = spot.classList.toggle('is-open');
        dot.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) closeAll(spot);
      });
    });
    document.addEventListener('click', (e) => { if (!root.contains(e.target)) closeAll(null); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(null); });

    /* переключатель вкладок: рисунок + набор точек + CTA.
       Управление: полосочки, стрелки по бокам, драг мышью (тач не трогаем —
       на мобиле горизонтальный жест панорамирует схему) */
    const tabsWrap = root.querySelector('[data-an-tabs]');
    if (tabsWrap) {
      const img = root.querySelector('[data-an-img]');
      const cta = root.querySelector('[data-an-cta]');
      const ctaName = root.querySelector('[data-an-cta-name]');
      const tabBtns = Array.from(tabsWrap.querySelectorAll('[data-an-tab]'));
      const activate = (btn) => {
        if (!btn || btn.classList.contains('is-on')) return;
        tabBtns.forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        const h = btn.dataset.handle;
        if (img) { img.src = btn.dataset.src; img.alt = btn.dataset.label; }
        closeAll(null);
        spots.forEach((s) => {
          const hs = s.dataset.handles || '';
          s.hidden = hs !== '' && !hs.split(',').includes(h);
        });
        if (cta) cta.setAttribute('href', btn.dataset.url || ('/products/' + h));
        if (ctaName) ctaName.textContent = btn.dataset.label;
      };
      const step = (dir) => {
        const i = tabBtns.findIndex((b) => b.classList.contains('is-on'));
        activate(tabBtns[(i + dir + tabBtns.length) % tabBtns.length]);
      };
      tabBtns.forEach((btn) => btn.addEventListener('click', () => activate(btn)));
      root.querySelectorAll('[data-an-nav]').forEach((nav) => {
        nav.addEventListener('click', () => step(parseInt(nav.dataset.anNav, 10)));
      });
      const view = root.querySelector('.anatomy__view');
      if (view) {
        let dragX = null;
        view.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (e.target.closest('.anatomy__dot, .anatomy__tip, [data-an-nav]')) return;
          dragX = e.clientX;
          view.classList.add('is-dragging');
          try { view.setPointerCapture(e.pointerId); } catch (err) {}
        });
        const endDrag = (e) => {
          if (dragX === null) return;
          const dx = e.clientX - dragX;
          dragX = null;
          view.classList.remove('is-dragging');
          if (Math.abs(dx) > 60) step(dx < 0 ? 1 : -1);
        };
        view.addEventListener('pointerup', endDrag);
        view.addEventListener('pointercancel', endDrag);

        /* горизонтальный скролл мышью/трекпадом над панелью: листает вкладки.
           Вертикаль не трогаем (страница скроллится как обычно); инерцию
           трекпада гасим паузой, чтобы один жест = одно переключение */
        let wheelAcc = 0;
        let wheelLock = 0;
        view.addEventListener('wheel', (e) => {
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
          e.preventDefault();
          const now = Date.now();
          if (now < wheelLock) return;
          if (wheelAcc !== 0 && Math.sign(e.deltaX) !== Math.sign(wheelAcc)) wheelAcc = 0;
          wheelAcc += e.deltaX;
          if (Math.abs(wheelAcc) > 90) {
            step(wheelAcc > 0 ? 1 : -1);
            wheelAcc = 0;
            wheelLock = now + 700;
          }
        }, { passive: false });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pdesc-more]').forEach((btn) => {
    const clamp = btn.parentElement.querySelector('[data-pdesc-clamp]');
    if (!clamp) return;
    const limit = parseFloat(getComputedStyle(clamp).getPropertyValue('--pdesc-h')) || 340;
    /* короткому тексту свёртка не нужна: снимаем клэмп и прячем кнопку */
    if (clamp.scrollHeight <= limit + 60) {
      clamp.classList.remove('is-closed', 'pdesc__clamp');
      btn.hidden = true;
      return;
    }
    const label = btn.querySelector('[data-pdesc-label]');
    btn.addEventListener('click', () => {
      const closed = clamp.classList.toggle('is-closed');
      btn.classList.toggle('is-open', !closed);
      if (label) label.textContent = closed ? btn.dataset.more : btn.dataset.less;
      clamp.style.maxHeight = closed ? '' : clamp.scrollHeight + 'px';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vb]').forEach((root) => {
    const video = root.querySelector('[data-vb-video]');
    const btn = root.querySelector('[data-vb-toggle]');
    if (!video) return;
    video.muted = true; /* страховка автоплея: атрибут muted браузеры иногда игнорируют после hydration */

    let userPaused = false;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { userPaused = true; video.removeAttribute('autoplay'); video.pause(); }

    const syncUI = () => root.classList.toggle('is-paused', video.paused);
    video.addEventListener('play', syncUI);
    video.addEventListener('pause', syncUI);
    syncUI();

    if (btn) {
      btn.addEventListener('click', () => {
        if (video.paused) { userPaused = false; video.play().catch(() => {}); }
        else { userPaused = true; video.pause(); }
      });
    }

    /* вне вьюпорта — пауза (экономим батарею), в кадре — продолжаем, если юзер сам не остановил */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) { if (!userPaused) video.play().catch(() => {}); }
          else { video.pause(); }
        });
      }, { threshold: 0.15 }).observe(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-in-box"] && !Shopify.designMode) return;
  try {
    
  /* плашка-хамелеон: save → atc (+один микро-шейк) → save; пауза на ховере */
  document.querySelectorAll('[data-wib-chm]').forEach((slot) => {
    const save = slot.querySelector('.wib__save');
    const atc = slot.querySelector('.wib__atc');
    if (!save || !atc) return;
    let hovered = false;
    let state = 'save';
    slot.addEventListener('mouseenter', () => { hovered = true; });
    slot.addEventListener('mouseleave', () => { hovered = false; });
    const swap = (showAtc) => {
      save.classList.toggle('is-on', !showAtc);
      save.classList.toggle('is-off', showAtc);
      atc.classList.toggle('is-on', showAtc);
      atc.classList.toggle('is-off', !showAtc);
      if (showAtc) {
        atc.classList.remove('shake');
        setTimeout(() => { atc.classList.add('shake'); }, 450);
      }
    };
    const tick = () => {
      if (!hovered) {
        state = state === 'save' ? 'atc' : 'save';
        swap(state === 'atc');
      }
      setTimeout(tick, state === 'atc' ? 4400 : 5900);
    };
    setTimeout(tick, 5500);
  });

  /* кнопка в плашке сабмитит форму покупки первого экрана */
  document.querySelectorAll('[data-wib-atc]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const form = document.querySelector('[data-pdp] form[action*="/cart/add"]');
      if (form) { form.requestSubmit ? form.requestSubmit() : form.submit(); }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
